<template>
	<div class="col-md-9">
		<!-- <AdSection/> -->
		<VideoSection :laugh="laugh"/>
	</div>
</template>

<script>
	import VideoSection from './VideoSection.vue'
	import AdSection from './AdSection.vue'

	export default {
		components: { AdSection, VideoSection },
		name: "MainBody",
		props: ['laugh']
	}
</script>